import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import {
  WorkLevelListRequest,
  WorkLevelListResponse,
  WorkLevel,
  WorkLevelCreateRequest,
  WorkLevelUpdateRequest,
  WorkLevelShortListResponse,
} from "./types";

/**
 * List
 */
export const workLevelListService = (params: WorkLevelListRequest) =>
  RestAPIClient.call<WorkLevelListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * List short
 */
export const workLevelListShortService = (params: WorkLevelListRequest) =>
  RestAPIClient.call<WorkLevelShortListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      params,
    },
  });

/**
 * Detail
 */
export const workLevelDetailService = (id: number) =>
  RestAPIClient.call<WorkLevel>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

/**
 * Create
 */
export const workLevelCreateService = (data: WorkLevelCreateRequest) =>
  RestAPIClient.call<WorkLevel>({
    method: HTTPRequestMethods.POST,
    url: `${Paths.Create}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });

/**
 * Update
 */
export const workLevelUpdateService = (data: WorkLevelUpdateRequest) =>
  RestAPIClient.call<WorkLevel>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${data.id}`,
    config: {
      requireAuthentication: true,
    },
    data,
  });
